import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as MessagingSvg } from './assets/messaging.svg';

const MessagingIcon = React.forwardRef((args, ref) => <SvgIcon component={MessagingSvg} ref={ref} {...args} />);

export default MessagingIcon;
